<div class="container">
    <img src="/assets/icons/logo.svg" alt="logo" class="logo">
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <footer>
        <span>&copy; All rights resetved {{ year }}</span>
    </footer>
</div>